import React from 'react';
import { connect } from 'react-redux';
import RequestsTabComponent from './RequestsTabComponent';

const mapStateToProps = ({ appReducer }) => ({
  locationSettings: appReducer.location.settings,
});

const RequestsTabContainer = connect(mapStateToProps)(({ locationSettings, match }) => (
  <RequestsTabComponent
    locationSettings={locationSettings}
    match={match}
  />
));

export default RequestsTabContainer;
